<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="6" md="8" sm="8" cols="12">
        <v-card>
          <v-card-title>API Anahtarı Ekle</v-card-title>
          <v-card-text>
            <v-select
              label="Yetki Kapsamı"
              :items="scopes"
              v-model="selectedScope"
            ></v-select>

            <v-text-field
              label="Geçerlilik Süresi"
              type="number"
              suffix="gün"
              v-model="lifetime"
            ></v-text-field>

            <v-autocomplete
              label="Kullanıcı"
              chips
              :items="dbClients"
              item-text="clientNickname"
              item-value="cldbid"
              v-model="selectedClient"
              deletable-chips
            >
              <template #item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.clientNickname }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.cldbid }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <key-text-field
              v-model="apiKey"
              label="Oluşturulan API Anahtarı"
            ></key-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text
              color="primary"
              :disabled="selectedScope === undefined"
              @click="addApiKey"
            >
              Oluştur
            </v-btn>

            <v-btn text @click="$router.go(-1)" color="primary">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    KeyTextField: () => import("@/components/KeyTextField"),
  },
  data() {
    return {
      scopes: [
        { text: "Yönet", value: "manage" },
        { text: "Yaz", value: "write" },
        { text: "Oku", value: "read" },
      ],
      selectedScope: undefined,
      dbClients: [],
      selectedClient: null,
      apiKey: "",
      lifetime: "", // gün cinsinden
    };
  },
  methods: {
    getDbClients() {
      return this.$TeamSpeak.fullClientDBList();
    },
    async addApiKey() {
      try {
        let options = {
          scope: this.selectedScope,
        };

        // Varsayılan olarak invoker (query kullanıcısı)
        if (this.selectedClient) options.cldbid = this.selectedClient;

        // Varsayılan: 14 gün (boş bırakılırsa backend tarafı kullanır)
        if (this.lifetime) options.lifetime = this.lifetime;

        this.apiKey = await this.$TeamSpeak
          .execute("apikeyadd", options)
          .then((res) => res[0].apikey);
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
  },
  async created() {
    try {
      this.dbClients = await this.getDbClients();
    } catch (err) {
      this.$toast.error(err.message);
    }
  },
};
</script>
